import { createSelector } from 'reselect';

import { getBuilder } from './getBuilder';

export const getCurrentRobotPartId = createSelector(
  getBuilder,
  builder => builder.currentRobotPartId
);
